// The map's listing markers from the icon zoom (kartvy 12, listvy 13): each home is drawn as its shape (a slab for flats, a
// gable for villas, a double gable for row houses, HOME_SHAPE_PATHS in homeTypeIcons.js) in white, with a halo,
// windows and door in its type's colour (purple for new builds); groups add a white count badge. Hover adds a
// glow in the same colour. Zoomed further out, listings stay small coloured dots.
import { homeTypeIconKey } from './homeTypeIcons.js';
import { NEW_CONSTRUCTION_COLOR } from './listingGroups.js';

// Shape markers: a white home with a halo, windows and door in its type's colour (the circles' colours).
const SHAPE_TYPE_COLORS = { apartment: '#4a96d0', house: '#1f7a62', rowhouse: '#b86b2d', fritidshus: '#b23a2e' };

// The glyph for the small round "merge" marker shown at a spread's centre (both views): two inward arrows
// (MUI's close-fullscreen), reading as "collapse the fanned-out homes back into their count marker".
export const SPREAD_COLLAPSE_GLYPH = '<svg viewBox="0 0 24 24" aria-hidden="true">'
    + '<path d="M22 3.41l-5.29 5.29L20 12h-8V4l3.29 3.29L20.59 2 22 3.41zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59 3.41 22z"/>'
    + '</svg>';

// Shape-marker sizes (radius = half the shape's box): homes, hovered homes, groups.
export const SHAPE_MARKER_RADIUS = 11.7; // a single home; 13 until 2026-11-01 (the owner: about 10% smaller)
export const SHAPE_GROUP_RADIUS = 15;
// Shape markers closer than this (px) merge into a group (listingGroups.js uses 25 for the circles).
export const SHAPE_OVERLAP_PX = 35;
// Below the closest zoom the homes and groups are drawn 5% smaller; at the closest zoom at full size.
const SHAPE_SCALE_BELOW_MAX_ZOOM = 0.95;
// Wider than a phone they're drawn 15% smaller again (the owner, 2026-11-01); phones keep the size for a finger.
const SHAPE_SCALE_DESKTOP = 0.85;
const isDesktopLayout = () => typeof window !== 'undefined' && Boolean(window.matchMedia?.('(min-width: 701px)').matches);
export const shapeRadiusAtZoom = (radius, zoom, maxZoom) => (
    radius * (zoom >= maxZoom ? 1 : SHAPE_SCALE_BELOW_MAX_ZOOM) * (isDesktopLayout() ? SHAPE_SCALE_DESKTOP : 1)
);

// The shape for a group: its most common home type.
export const shapeKeyForListings = (listings) => {
    const counts = new Map();
    (listings || []).forEach((listing) => {
        const key = homeTypeIconKey(listing?.type);
        counts.set(key, (counts.get(key) || 0) + 1);
    });
    let best = 'house';
    let bestCount = -1;
    counts.forEach((n, key) => {
        if (n > bestCount) {
            best = key;
            bestCount = n;
        }
    });
    return best;
};

// Canvas visual of a shape marker for a group or a single listing (count null); new builds are purple.
// visited (a single home opened in the full view): the body is filled with the type colour and the windows
// and door go white (Fylld kropp), plus a green check badge (drawHomeShape) — instead of the white house.
export const shapeMarkerVisual = (listings, { radius, count = null, isNew = false, visited = false }) => {
    const shape = shapeKeyForListings(listings);
    const color = isNew ? NEW_CONSTRUCTION_COLOR : SHAPE_TYPE_COLORS[shape];
    if (visited) {
        return { shape, radius, fill: color, halo: color, detail: '#ffffff', count, visited: true, weight: 0 };
    }
    return { shape, radius, fill: '#ffffff', halo: color, detail: color, count, weight: 0 };
};
